import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { SignupContainer } from '@src/components/sco/Account/SignupContainer';
import { SignupPaymentForm } from '@src/components/sco/Account/SignupPaymentForm';
import { FLUSH_PAYMENT_FORM_CONTAINER } from '@src/components/sco/Conversion/controller/ConversionPaymentStep';
import { ConversionPaymentSummary } from '@src/components/sco/Conversion/controller/ConversionPaymentSummary';
import { resolveCheckoutCouponCode } from '@src/components/sco/Conversion/controller/checkoutParams';
import { STARTUPS_PRO_PRODUCT_ID } from '@src/components/sco/Conversion/intent';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { useRouter } from 'next/navigation';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useCookie } from 'react-use';
export { getServerSideProps } from '@src/lib/server-side-rendering';
const LADDER_PRODUCT_IDS = [
  // STARTUPS_PRO_PRODUCT_ID, ADVISOR_TEAM_PRODUCT_ID
];
export default function Page() {
  const $ = _c(22);
  const {
    currentUser
  } = useCurrentUser();
  const router = useRouter();
  const params = useSearchParams();
  const activeContent = useActiveContentContext();
  const [promoCookie] = useCookie("sco_promo");
  const productId = params.get("productId") || STARTUPS_PRO_PRODUCT_ID;
  const t0 = currentUser?.defaultCouponCode;
  let t1;
  if ($[0] !== params || $[1] !== promoCookie || $[2] !== t0) {
    t1 = resolveCheckoutCouponCode({
      params,
      defaultCouponCode: t0,
      promoCookie
    });
    $[0] = params;
    $[1] = promoCookie;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const couponCode = t1;
  let t2;
  if ($[4] !== activeContent) {
    t2 = () => {
      activeContent.setSiteSection("signup.payment");
    };
    $[4] = activeContent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useUniversalEffect(t2);
  let t3;
  if ($[6] !== params || $[7] !== router) {
    t3 = () => {
      if (params.get("productId") == "scom-fac-fg-premium-annual") {
        router.push(`/accelerator/payment?productId=scom-fac&termId=year&couponCode=${params.get("facCouponCode") || ""}`);
      }
      if (params.get("productId") == "scom-accelerator-advisor-monthly") {
        router.push(`/accelerator/payment?productId=scom-accelerator-advisor&termId=month&couponCode=${params.get("promo") || ""}`);
      }
      if (params.get("productId") == "scom-accelerator-community-monthly") {
        router.push(`/accelerator/payment?productId=scom-accelerator-community&termId=month&couponCode=${params.get("promo") || ""}`);
      }
      if (params.get("productId") == "scom-founder-group-2-monthly") {
        router.push(`/accelerator/payment?productId=scom-accelerator-advisor&termId=month&couponCode=${params.get("promo") || ""}`);
      }
      if (params.get("productId") == "scom-founder-group-1-monthly") {
        router.push(`/accelerator/payment?productId=scom-accelerator-community&termId=month&couponCode=${params.get("promo") || ""}`);
      }
    };
    $[6] = params;
    $[7] = router;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== params) {
    t4 = params.get("productId");
    $[9] = params;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = [t4];
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t3, t5);
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ScoSiteNavBar />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const T0 = VStack;
  const t7 = "center";
  const t8 = "center";
  const t9 = "90vh";
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [0, 0, 0, 6, 6];
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = "full";
  const t12 = LADDER_PRODUCT_IDS.includes(productId) ? <ConversionPaymentSummary couponCode={couponCode} productId={productId} termId={params.get("termId")}><SignupPaymentForm allowProductChange={true} containerProps={FLUSH_PAYMENT_FORM_CONTAINER} couponCode={couponCode} hidePricing={true} hideProductTitle={true} paymentProvider="stripe-methods" productId={productId} returnToHref="/onboarding/welcome" showCouponForm={true} termId={params.get("termId")} /></ConversionPaymentSummary> : <SignupContainer productId={params.get("productId")}><SignupPaymentForm allowProductChange={true} couponCode={couponCode} paymentProvider="stripe-methods" productId={productId} returnToHref="/onboarding/welcome" showCouponForm={true} termId={params.get("termId")} /></SignupContainer>;
  let t13;
  if ($[15] !== T0 || $[16] !== t10 || $[17] !== t12) {
    t13 = <T0 align={t7} justify={t8} minHeight={t9} padding={t10} width={t11}>{t12}</T0>;
    $[15] = T0;
    $[16] = t10;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t6) {
    t14 = <>{t6}{t13}</>;
    $[19] = t13;
    $[20] = t6;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
}